import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import Arrow from '@ep/images/arrow.svg';
import theme from '@ep/theme';
import React from 'react';

export interface SeeMoreLinkProps
  extends React.HTMLAttributes<HTMLAnchorElement> {
  label: string;
  to: string;
  as?: string;
}

const StyledArrow = styled(Arrow)`
  margin-left: 1rem;
  width: 1rem;
  transform: translateX(-0.75rem);
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.shorter,
  })};

  ${Link}:hover & {
    transform: translateX(0);
  }
`;

function SeeMoreLink({ label, ...rest }: SeeMoreLinkProps) {
  return (
    <Link bold {...rest}>
      <span>{label}</span>
      <StyledArrow />
    </Link>
  );
}

export default SeeMoreLink;
